import React from 'react';
import { Text } from '@components';

// CSS Style for this module
import styles from './label.module.scss';

interface LabelProps {
	children: React.ReactNode;
	isRequired?: boolean;
	hideOptional?: boolean;
	hideRequired?: boolean;
	for?: string;
}

export const Label = ({
	children,
	isRequired = false,
	hideOptional = false,
	hideRequired = false,
	for: htmlFor,
}: LabelProps) => {
	return (
		<label className={styles.label} htmlFor={htmlFor}>
			{isRequired && !hideRequired && <abbr className={styles.required}>*</abbr>}
			<Text variant="label">
				{children}
				{isRequired === false && !hideOptional && (
					<span className={styles.optional}>(Optional)</span>
				)}
			</Text>
		</label>
	);
};
